// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --main-background-color: #F0F8E7;
    --meal-box-color: #A5D6A7;
    --highlight-color: #A5D6A7;
    --navbar-background-color: #FFFFFF;
    --footer-background-color: #004D40;
  }`, "",{"version":3,"sources":["webpack://./src/styles/Colors.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;IAC1B,kCAAkC;IAClC,kCAAkC;EACpC","sourcesContent":[":root {\n    --main-background-color: #F0F8E7;\n    --meal-box-color: #A5D6A7;\n    --highlight-color: #A5D6A7;\n    --navbar-background-color: #FFFFFF;\n    --footer-background-color: #004D40;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
